import React, { Fragment } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ItemBox from '../../components/itens/item';


function ListaContratosScreen() {
    return (
        <Fragment>
            <Head titulo="Contratos" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Fragment>
                    <Row xs={12} lg={2}>
                        <Col>
                            <ItemBox
                                titulo={"Contratos"}
                                descricao={<Fragment><p>Clique aqui e veja a listagem de contratos firmados por essa prefeitura.</p><br /></Fragment>}
                                awesome={"faFileSignature"}
                                link={"contratos/listar"}
                            />
                        </Col>
                        <Col>
                            <ItemBox
                                titulo={"Fiscais de Contratos"}
                                descricao={<Fragment><p>Clique aqui e veja a listagem de servidores municipais responsáveis pela fiscalização dos contratos firmados por essa prefeitura.</p><br /></Fragment>}
                                awesome={"faUserShield"}
                                link={"contratos/fiscais"}
                            />
                        </Col>
                        <Col>
                            <ItemBox
                                titulo={"Contratados"}
                                descricao={<Fragment><p>Clique aqui e veja a listagem de empresas sancionadas administrativamente por essa prefeitura.</p><br /></Fragment>}
                                awesome={"faAddressBook"}
                                link={"contratos/sancionados"}
                            />
                        </Col>
                        <Col>
                            <ItemBox
                                titulo={"Licitantes"}
                                descricao={<Fragment><p>Clique aqui e veja a listagem de licitantes nessa prefeitura.</p><br /></Fragment>}
                                awesome={"faIdCardClip"}
                                link={"contratos/licitantes"}
                            />
                        </Col>
                        <Col>
                            <ItemBox
                                titulo={"Nova Lei de Licitações"}
                                descricao={<Fragment><p>Confira no link abaixo as minutas, documentos padrões e legislação referente à Nova Lei de Licitações no Município de Macuco</p><br /></Fragment>}
                                awesome={"faScaleBalanced"}
                                link={"https://prefeituramacuco.rj.gov.br/site/transparencia-e-acesso-a-informacao/legislacao-e-minutas-nova-lei-de-licitacoes-e-contratos.html"}
                            />
                        </Col>
                        <br />
                    </Row>
                </Fragment>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListaContratosScreen;